module.exports = __webpack_public_path__ + "../assets/img/c3f1e71fa94579a985394a51755328aa.webp";